module.exports = __webpack_public_path__ + "static/media/imgAdobe.fe7c6aff.png";